module.exports = __webpack_public_path__ + "static/media/square2.d805024e.jpg";